var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"greeting"},[_vm._v("Hello "+_vm._s(_vm.name)+_vm._s(_vm.exclamationMarks))]),_c('button',{on:{"click":_vm.decrement}},[_vm._v("-")]),_c('button',{on:{"click":_vm.increment}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }